import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import messageries from '@/views/messageries/emailStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import tarifModule from './tarif-module'
import catalogueModule from './catalogue-module'
import produitModule from './produit-module'
import assureurModule from './assureur-module'
import serviceModule from './service-module'
import quickwinsTarificateurModule from './quickwins/tarificateur'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    messageries,
    'app-ecommerce': ecommerceStoreModule,
    tarifModule,
    catalogueModule,
    produitModule,
    assureurModule,
    serviceModule,
    quickwinsTarificateurModule
  },
  strict: process.env.DEV,
})
